import { ContentBreadcrumbFragment_context } from "__generated__/types";
import { BreadcrumbItem } from "common/components/breadcrumb/Breadcrumb";
import { useMyExamSyllabus } from "common/hooks/useMyExamSyllabus";
import {
  buildBreadcrumbs,
  decorateBreadcrumbs,
} from "common/components/breadcrumb/breadcrumb-utils";

export type ContentExists = {
  index: number;
  value: ContentBreadcrumbFragment_context;
};

export type NonExistingContent = {
  index: -1;
  value?: never;
};

export type ContentInList = ContentExists | NonExistingContent;

export function getSyllabus(
  context: ContentBreadcrumbFragment_context[],
): ContentInList {
  for (let i = 0; i < context.length; i++) {
    const value = context[i];
    if (value.__typename === "ExamSyllabus") {
      return { index: i, value };
    }
  }
  return { index: -1 };
}

export function useBreadcrumbs(
  context: ContentBreadcrumbFragment_context[],
  isAdminPage: boolean,
): BreadcrumbItem[] {
  const syllabusInContext = getSyllabus(context);
  const breadcrumbs = buildBreadcrumbs(
    context,
    isAdminPage,
    !!syllabusInContext.value,
  );
  const { myExamSyllabi } = useMyExamSyllabus();

  return decorateBreadcrumbs(
    breadcrumbs,
    isAdminPage,
    syllabusInContext,
    myExamSyllabi,
  );
}
